import { ExclamationThickIcon } from './ExclamationThickIcon';

/**
 * author: frankgrinaert
 * id 2DEA5CA1-8412-4DA4-95C4-7E1AA2C27404
 * name exclamation-thick
 * version: 4.6.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/exclamation-thick.svg
 * tags
 */
export const ExclamationBoldIcon = ExclamationThickIcon;
export default ExclamationBoldIcon